exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box{height:58px}.ghost{opacity:.5}.drag-handle,.remove-box-btn{position:absolute;border-radius:100px;right:-1px}.drag-handle{cursor:move!important;bottom:1px}.remove-box-btn{top:-1px}.drag-handle i,.remove-box-btn i{font-size:10px}", ""]);

// exports
